<template>
  <modal
    elem-id="modal_setup_fee_market"
    :title="modalTitle"
    :show="isVisible"
    size="medium"
    :close-label="t('Fechar')"
    :save-label="t('Salvar mercado')"
    save-test-id="setup-fee-market-submit"
    :save-fn="handleSave"
    :save-disabled-fn="() => formRef?.isSaving.value === true"
    @close="closeModal"
    @dismiss="closeModal"
  >
    <template v-if="isVisible">
      <setup-fee-market-form
        ref="formRef"
        :market="currentMarket"
        @saved="handleSaved"
        @validation-failed="() => {}"
      />
    </template>
  </modal>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n'
import { eventBus } from '../../../eventBus'
import { log } from '../../../utils/DebugLogger'
import Modal from '../../../ui/Modal.vue'
import SetupFeeMarketForm from './SetupFeeMarketForm.vue'
import type { SetupFee_DefaultRow } from '../../../contracts/SetupFee_DefaultRow'

interface MarketFormExposed {
  handleSubmit: () => Promise<boolean>
  isSaving: { value: boolean }
}

interface ModalOpenPayload {
  market?: SetupFee_DefaultRow | null
}

const { t } = useI18n()

const isVisible = ref(false)
const currentMarket = ref<SetupFee_DefaultRow | null>(null)
const formRef = ref<MarketFormExposed | null>(null)

const modalTitle = computed(() =>
  currentMarket.value != null ? t('Editar mercado de implantação') : t('Criar mercado de implantação'),
)

function openModal(payload?: ModalOpenPayload): void {
  log('SetupFeeMarketModal', 'openModal', 'Abrindo modal', payload)
  currentMarket.value = payload?.market ?? null
  isVisible.value = true
}

function closeModal(): void {
  log('SetupFeeMarketModal', 'closeModal', 'Fechando modal')
  isVisible.value = false
  currentMarket.value = null
}

async function handleSave(): Promise<boolean> {
  if (formRef.value) {
    return formRef.value.handleSubmit()
  }
  return false
}

function handleSaved(): void {
  // saveDefault already refreshed the shared defaultsList singleton; the
  // refresh event keeps any mounted table in sync and the modal closes.
  eventBus.emit('globalMessage.success', t('Mercado de taxa de implantação salvo'))
  eventBus.emit('setupFeeMarkets.refresh')
  closeModal()
}

onMounted(() => {
  eventBus.on('modal.setupFeeMarket.open', openModal)
  eventBus.on('modal.setupFeeMarket.close', closeModal)
})

onBeforeUnmount(() => {
  eventBus.off('modal.setupFeeMarket.open', openModal)
  eventBus.off('modal.setupFeeMarket.close', closeModal)
})
</script>
